import { createSelector } from '@reduxjs/toolkit';
import { ReducerState } from '../../store.types';

export const companyAddressSelector = (state: ReducerState) => state.companyAddress;

export const companyAddressLoadingSelector = createSelector(
  companyAddressSelector,
  (state) => state.fetchStatus === 'pending',
);
